(function () {
  const bar = document.getElementById('mn-sticky-cta-new');
  if (!bar) return;

  const offerBtn = document.querySelector('.offer-repeat .btn-primary');
  const footer = document.querySelector('#mn-lp .footer');

  let visible = false;
  let ticking = false;

  function isOfferBtnGone() {
    return offerBtn && offerBtn.getBoundingClientRect().bottom < 200;
  }

  function isFooterVisible() {
    if (!footer) return false;
    const rect = footer.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function update() {
    const shouldShow = isOfferBtnGone() && !isFooterVisible();
    if (shouldShow === visible) return;

    visible = shouldShow;
    bar.style.opacity = visible ? '1' : '0';
    bar.style.pointerEvents = visible ? 'auto' : 'none';
    bar.setAttribute('aria-hidden', String(!visible));
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
